import styled from "styled-components";
import Spinner from "./Spinner";
import { getWindowHeight } from "../utils";

const LoaderModal = ({ show }: { show: boolean }) => {
  return show ? (
    <>
      <Backdrop />
      <ModalContainer>
        <ModalContent>
          <h2>Uw data wordt opgeslagen ...</h2>
          <SpinnerContainer>
            <Spinner data-testid="loader" size="large" />
          </SpinnerContainer>
        </ModalContent>
      </ModalContainer>
    </>
  ) : null;
};

const SpinnerContainer = styled.div`
  padding-top: 1rem;
  padding-bottom: 2rem;
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: ${getWindowHeight()};
  background-color: rgba(0, 0, 0, 0.2);
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background-color: white;
  max-width: 100vw;
  max-height: ${getWindowHeight()};

  @media only screen and (min-width: 480px) {
    width: 480px;
  }

  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  @media only screen and (max-width: 480px) {
    width: 100vw;
  }
`;

const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem;
`;

export default LoaderModal;
